<template>
	<div id="auto-complete">
		<p v-if="insideTable && readonly" style="margin:0">{{ innerValue }}</p>
		<v-autocomplete
			v-else
			v-model="localValue"
			:items="readonly && itemText ? customItems : localItems"
			:item-text="itemText"
			:item-value="itemValue"
			:label="!insideTable ? label : ''"
			:hide-selected="hideSelected"
			:disabled="(readonly && !insideTable) || disabledValue"
			:outlined="!insideTable"
			:dense="!insideTable"
			:clearable="clearable"
			:readonly="readonly"
			flat
			:single-line="insideTable"
			color="primary"
			style="width: 100%"
			ref="BeeAutocomplete"
			:rules="rules"
			:filter="filter"
			:menu-props="{transition:'slide-y-transition', offsetY: true, offsetOverflow: true, openOnClick: false, maxHeight: 265}"
			:hide-details="(!!hideDetails) ? 'hide' : false"
			@focus="onFocus()"
			@blur="$emit('blur')"
			@keydown="$emit('keydown', $event)"
			@keypress="$emit('keypress', $event)"
			@click:clear="$emit('input', value)"
			@change="$emit('change', $event)"
			@input="$emit('input', $event)"
			@keydown.enter.prevent="$emit('keydown-enter-prevent')"
			@keydown.esc.prevent="$emit('keydown-esc-prevent')"
			@keydown.ctrl.down.native="$emit('keydown-ctrl-down')"
		>
			<template v-slot:item="data">
				<slot name="item" v-bind="data">{{data.item[itemText]}}</slot>
			</template>
			
			<template v-slot:selection="data">
				<slot name="selection" v-bind="data">{{data.item[itemText]}}</slot>
			</template>
			<template v-slot:no-data>
				<v-list-item>
					{{$t('no-data')}}
				</v-list-item>
			</template>
		</v-autocomplete>
	</div>
</template>
<script>
import baseBeeComponent from '../../baseBeeComponent';
export default {
	name: 'BeeAutocomplete',

	mixins: [baseBeeComponent],

	props:[
		'rules',
		'value',
		'items',
		'label',
		'itemText',
		'insideTable',
		'readonly',
		'itemValue',
		'emptyState',
		'clearable',
		'disabled',
		'filter',
		'hideDetails',
		'hideSelected'
	],
	
	computed: {
		localValue: {
			get: function () {
				return this.value ? this.value : (this.readonly ? null : this.value)
			},
			set: function (value) {
				this.$emit("input", value);
			},
		},
		localItems: {
			get: function () {
				return this.items;
			},
			set: function (value) {
				this.items = value
			},
		},

		customItems(){
			return [{ [this.itemValue]: null, [this.itemText]: this.emptyState }, ...this.localItems]
		},

		innerValue(){
			return this.localValue
				? this.localItems.find(c => c[this.itemValue] == this.localValue)[this.itemText]
				: this.emptyState;
		},

		valid: {
			get() { return this.$refs.BeeAutocomplete.valid },
			set(val) { this.$refs.BeeAutocomplete.valid = val },
		},
		hasFocused: {
			get() { return this.$refs.BeeAutocomplete.hasFocused },
			set(val) { this.$refs.BeeAutocomplete.hasFocused = val },
		}
	},
	methods:{
		onFocus () {
			if(this.insideTable){
				var doc = document.body
				var beeAutoCompletePosition = document.querySelector('#auto-complete').getBoundingClientRect().top
				if((beeAutoCompletePosition * 100)/doc.scrollHeight > 40)
					this.$refs.BeeAutocomplete.menuProps.maxHeight = 150
			}
			this.$emit('focus')
		},
		focus() {
			this.$refs.BeeAutocomplete.focus();
		},
		validate() {
			return this.$refs.BeeAutocomplete.validate();
		},
		resetValidation() {
			this.$refs.BeeAutocomplete.resetValidation();
		}
	},

	i18n: {
		messages: {
			ar: { 'no-data': 'لا تتوفر بيانات' },
			en: { 'no-data': 'No data' },
			es: { 'no-data': 'Sin datos' },
		}
	}
}
</script>